module.exports = __webpack_public_path__ + "media/assets/images/tour/1_Tour_2-64687d29b3639766938e237a08078fcc.png";